import React, { useEffect, useState } from "react";

const FAQItem = ({ question, answer }) => {
  const [isActive, setIsActive] = useState(false);
  const slug = question.toLowerCase().replace(/\s+/g, "-");

  const handleClick = () => {
    setIsActive(!isActive);
  };

  return (
    <li className={`accordion-faq__item ${isActive ? "accordion-faq__item--active" : ""}`} aria-expanded={isActive}>
      <div className="faq-block__item">
        <p
          data-slug={slug}
          className={`faq-block__item-question ${isActive ? "faq-block__item-question--active" : ""}`}
          onClick={handleClick}
        >
          {question}
        </p>
        <div
          className={`faq-block__item-answer ${isActive ? "faq-block__item-answer--active" : ""}`}
          dangerouslySetInnerHTML={{ __html: answer }}
        />
      </div>
    </li>
  );
};

export default FAQItem;
